'use strict';
const angular = require('angular');

export class mailComposerSendComponent {
  /*@ngInject*/
  constructor(VotingsService, MailsService, VoterGroupsService, $uibModal, SettingsService, ClosingSnapshotsService) {

    this.MailsService = MailsService;
    this.VotingsService = VotingsService;
    this.VoterGroupsService = VoterGroupsService;
    this.ClosingSnapshotsService = ClosingSnapshotsService;
    this.$uibModal = $uibModal;

    this.votings = [];
    this.allRecipients = [];
    this.recipients = [];

    this.ownToggle = false;
    this.ownRecipients = "";

    this.targetVoters = true;

    SettingsService.getByName({name: 'client'}, settings => {

      this.useSuite = settings.data.useSuite;

      VotingsService.query(data => {

        let tz = moment.tz.guess();
        let votings = data.map(voting => {
          voting.nameAndDate = voting.name + " (" + moment(voting.date).tz(tz).format('ll') + ")";
          return voting;
        });

        this.upcoming = votings
          .filter(v => v.state != 'closed')
          .filter(vote => moment(vote.period.till).isAfter(moment(), 'days')
            || moment(vote.period.till).isSame(moment(), 'days'))
          .map(v => {
            v.group = 'Current and Upcoming';
            return v
          });

        this.past = votings
          .filter(vote => vote.state == 'closed' || moment(vote.period.till).isBefore(moment(), 'days'))
          .map(v => {
            v.group = 'Past';
            return v
          });

        this.votings.push(...this.upcoming, ...this.past);
      });

    });
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  filterRecipients() {
    this.processing = true;

    let removeDuplicatesIds = arr => {
      let found = {};
      return arr.filter(obj => !found[obj._id] && (found[obj._id] = true));
    };

    if (this.voterGroup.type == 'contacts') {
      this.filterNotOptIn = false;
      this.filterOptIn = false;
      this.targetPrimaryOwners = false;
      this.targetOtherOwners = false;
      this.targetVoters = true;
    }

    if (this.targetPrimaryOwners || this.targetOtherOwners) {
      this.filterNotVoted = false;
      this.filterNotOptIn = false;
      this.filterOptIn = false;
    }

    this.recipients = [];

    if (this.targetVoters)
      this.recipients = this.recipients.concat(this.allVoters);

    if (this.targetPrimaryOwners)
      this.recipients = this.recipients.concat(this.allPrimaryOwners);

    if (this.targetOtherOwners)
      this.recipients = this.recipients.concat(this.allOtherOwners);

    if (this.filterConsent)
      this.recipients = this.recipients.filter(r => r.customFields && r.customFields.eContactConsent);

    if (this.filterNotOptIn)
      this.recipients = this.recipients.filter(r => !r.customFields || !r.customFields.eVotingConsent);

    if (this.filterOptIn)
      this.recipients = this.recipients.filter(r => r.customFields && r.customFields.eVotingConsent);

    if (this.filterNotVoted)
      this.recipients = this.recipients.filter(r => !this.voting.votes.find(v => String(v.voter) == String(r._id)));

    this.recipients = removeDuplicatesIds(this.recipients);
    console.log(this.recipients);

    if (this.ownToggle) {
      this.ownRecipients.split("\n").forEach((recipient,idx) => {

        let trimmedRecipient = recipient.trim();
        if (!trimmedRecipient)
          return;

        let splittedRecipient = trimmedRecipient.split("@");
        if (splittedRecipient.length !== 2)
          return;

        this.recipients.push({
          company: "Additional E-Mail #" + (idx+1),
          email: [{primary:true, address: trimmedRecipient}]
        });
      });
    }

    this.processing = false;
  }

  updateVoterGroup() {
    this.recipients = [];
    this.allVoters = [];
    this.allPrimaryOwners = [];
    this.allOtherOwners = [];

    this.processing = true;

    if (!this.voting.voterGroup && !this.voting.closingSnapshot)
      return;

    let updateData = vg => {
      this.voterGroup = vg;

      this.allVoters = (vg.type == 'contacts')
        ? vg.contacts
        : vg.properties
          .filter(ppty => ppty.eVoting && ppty.eVoting.voter && this.getPrimaryEmail(ppty.eVoting.voter) !== "-")
          .map(ppty => ppty.eVoting.voter);

      this.allPrimaryOwners = (vg.type == 'contacts')
        ? []
        : vg.properties
          .filter(ppty => ppty.contacts && ppty.contacts.length && ppty.contacts.find(c => c.type == 'primary-owner' && c.contact && this.getPrimaryEmail(c.contact) !== "-"))
          .map(ppty => ppty.contacts.filter(c => c.type == 'primary-owner' && this.getPrimaryEmail(c.contact) !== "-").map(c => c.contact)).map(c => c[0]);

      this.allOtherOwners = (vg.type == 'contacts')
        ? []
        : vg.properties
          .filter(ppty => ppty.contacts && ppty.contacts.length && ppty.contacts.find(c => c.type == 'owner' && c.contact && this.getPrimaryEmail(c.contact) !== "-"))
          .map(ppty => ppty.contacts.filter(c => c.type == 'owner' && this.getPrimaryEmail(c.contact) !== "-").map(c => c.contact)).map(c => c[0]);

      this.filterRecipients();
    };

    if (this.voting.state == 'closed' && this.voting.closingSnapshot) {

      this.ClosingSnapshotsService.get({id: this.voting.closingSnapshot}, snapshot => {
        if (snapshot.type == 'contacts')
          snapshot.contacts = snapshot.data;
        else
          snapshot.properties = snapshot.data;

        delete snapshot.data;

        updateData(snapshot);
      });

    } else {
      let vgId = (this.voting.voterGroup._id) ? this.voting.voterGroup._id : this.voting.voterGroup;

      let VG_QUERY_METHOD = (this.useSuite) ? "getWithDataSuite" : "getWithData";
      this.VoterGroupsService[VG_QUERY_METHOD]({id: vgId}, vg => updateData(vg));
    }

  }

  getComposedName(contact) {
    let composedName = "";

    if (contact.lastName && contact.firstName) {
      composedName = contact.lastName + ", " + contact.firstName;
      if (contact.middleName)
        composedName += " " + contact.middleName;
    }

    if (contact.company) {
      if (composedName == "")
        composedName += contact.company;
      else
        composedName += "<br/>" + contact.company;
    }

    return composedName || "-";
  }

  getPrimaryEmail(contact) {
    if (!contact || !contact.email || !contact.email.length)
      return "-";

    let email = contact.email.find(email => email.isPrimary) || contact.email[0] || {address:'-'};

    return email.address;
  }

  openRecipientsModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'datatableViewer',
      resolve: {
        config: function () {
          return {
            data: that.recipients.map(c => [that.getComposedName(c), that.getPrimaryEmail(c)]),
            settings: {
              "columns": [
                "Name",
                "Email"
              ]
            },
            name: "Recipients"
          }
        }
      },
      size: 'lg'
    });
  }


  ok(recipientListId) {
    let mail = this.config.mail;

    mail.recipients = this.getRecipients(recipientListId);
    mail.voting = this.voting._id;

    this.MailsService.send({id: mail._id}, mail, (res) => {
      this.close({$value: {mailId: mail._id}});
    }, (err) => {
      console.log("Could not send mail");
    });
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  getRecipients(ids) {
    let recipients = this.recipients
      .filter(r => this.getPrimaryEmail(r) !== "-")
      .map(r => this.getPrimaryEmail(r));

    /* remove duplicates:
     * https://stackoverflow.com/questions/1960473/get-all-unique-values-in-a-javascript-array-remove-duplicates */
    return [...new Set(recipients)];
  }

}

export default angular.module('conduApp.mailComposerSendComponent', [])
  .component('mailComposerSendComponent', {
    template: require('./mail-composer-send.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: mailComposerSendComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/mail-composer/send/mail-composer-send.component.js